// extracted by mini-css-extract-plugin
module.exports = {"notice":"TermsNotice_notice__BPHeE","link":"TermsNotice_link__WaLzC"};